import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-explorenav',
  templateUrl: './explorenav.component.html',
  styleUrls: ['./explorenav.component.scss']
})
export class ExploreNavComponent implements OnInit {
  modalRef: BsModalRef;
  showNav = true;

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
  }

  openModal(template: TemplateRef<any>) {
    const config: ModalOptions = { class: 'custom-modal' };
    this.modalRef = this.modalService.show(template, config);
  }

}

